import React, { Component } from 'react';

import commonUtil from './../../../../../../utils/commonUtil';
import AddressName from './addressName';
import CheckBox from '../../../../../../components/ZUILib/CheckBox';

const channel = commonUtil.getChannel();

class AddressCelebrityData extends Component {

   constructor(props) {
    super(props);
    this.state = {
      checkedAddress : []
    };    
  }

  getSelectedAddressId = (data) => {    
    let addressid = data.id; 
    if (data.checked) {       
      this.props.HandleDefaultAddresId(addressid, 'add')
      this.setState({
        checkedAddress: [...this.state.checkedAddress, addressid], 
      })
    } else {      
      this.props.HandleDefaultAddresId(addressid, 'remove');
    }
  }
    
  render() {
    const props = this.props;
    const labels = props.labels;
    const address = props.address;
    const addressObject = props.addressObject;
    const numberOfAddresses = props.numberOfAddresses;
    const addressDataHtmlFn = props.addressDataHtmlFn;
    const { firstName = '', motherName = '', lastName = '', nickName = '',nickname } = addressObject || {};
    const celebrityOptions = props.celebrityOptions;  
    
    // Determine display name: prefer nickName, then nickname, else full name
    let displayName = '';
    if (nickName) {
      displayName = nickName;
    } else if (nickname) {
      displayName = nickname;
    } else {
      displayName = `${firstName} ${motherName} ${lastName}`;
    }
     
    return (
      <React.Fragment>
        <div
          className="addressInfo"
          style={{
            width: channel === 'web' && numberOfAddresses === 1 ? 352 : '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,           
            padding: '24px 0px 16px 0px',
            // backgroundColor: '#fff',
            // marginBottom: '24px'
          }}
        >          

         {/* <span className="adminName">
            {commonUtil.sentenceCase(`${firstName} ${motherName} ${lastName}`)}
          </span> */}

          {/* <p className="addressData" style={{ minHeight: 60 }}>{addressDataHtmlFn ? addressDataHtmlFn(addressObject) : address}</p> */}
             
            <div className="addressSummary newAddressSummary" style={{ display: 'flex', gap: 10 }}>
            <div className="multipleAddress">
              <div className="inputBlock" style={{ marginLeft: channel !== 'web' && "24px", marginTop: channel === 'web' ? "3px" : "1px" }}>
                <CheckBox
                  className={'mobileCheckbox'}
                  id={addressObject?.addressId  || this.props.index}
                  value={addressObject.addressId || addressObject.firstName}
                  name={addressObject.firstName}
                  getSelectedValue={this.getSelectedAddressId}
                  checked={addressObject?.disabletheCheckbox}
                  disabled={addressObject.disabletheCheckbox || false}
                   
                />
              </div>
            </div>
            <div>
              <p>  <b>{commonUtil.sentenceCase(displayName)}</b> </p>
              {addressObject.defaultAddress &&
                <p style={{
                  fontSize: '10px',
                  fontWeight: '400',
                  color:'var( --main-color-brand)'
                }}>Predeterminada</p>}
              
              <p className='newAddressText'> {addressDataHtmlFn ? addressDataHtmlFn(addressObject) : address} </p>
              <p className="newAddressRegistered marginTop-16">Dirección registrada en la mesa de regalos</p>
            </div>
          </div> 
          {/* {celebrityOptions.length > 1 && <div className="form">
            {channel === 'web' &&
              <span>
                {commonUtil.getLabel(labels.editEventDelivery, 'eventManagement.address.dropdownLabel')}
              </span>
            }
          </div>} */}
        </div>
      </React.Fragment>
    );
  }
}

export default AddressCelebrityData;
